module.exports = __webpack_public_path__ + "static/media/AN.82166bf2.jpg";